module.exports = __webpack_public_path__ + "static/p-2-a782743e5f74bf7a2c355e760ecbd02b.jpg";